<template>
	<div id="Release">
		<div class="g-right-top width800">个人中心 / 我的发布</div>
		<div class="g-right-middle margintop20 width800">
			<div class="wdfb-list" v-for='(item,key) in list' :key='item.id'>

				<p>

					<div class="float-left">
						<i class="yd-icon"></i>
						<router-link :to="'/group_admin/groupinfor/'+item.id"><span style="padding-left: 20px;">{{item.id}}-{{item.movie_name}}</span></router-link>
					</div>
					<div class="float-right" style="width: 130px;">
						<span style="width:100px">{{item.create_time}}</span>
						<span @click="del_list(key,item.id)" class="el-icon-delete icon-del float-right"></span>

					</div>
					<div class="clearfix"></div>
				</p>
			</div>
		</div>
	</div>
</template>
<script>
	import Axios from 'axios'
	import storage from '../../storage/storage.js'
	export default {
		data() {
			return {
				list: [],
				id: '',
				modal2: false,
				modal_loading: false,

			}
		},
		methods: {

			getdata() {

				var api = 'http://api.yopoo.cn/api/centre/issuelist'
				let token = storage.get('token')
				Axios.get(api, {
					headers: {
						'Authorization': token
					}
				}).then((res) => {

						this.list = res.data
					},
					(err) => {
						console.log(err)
					})
			},
			del_list(key, id) {
				this.$Modal.confirm({
					title: '警告！',
					content: '确认删除？',
					onOk: () => {
						var api = 'http://api.yopoo.cn/api/centre/deletecrew?id=' + id

						let token = storage.get('token')

						Axios.get(api, {
							headers: {
								'Authorization': token
							}
						}).then((res) => {

								if (res.data.code == 200) {
									this.$message({
										message: res.data.msg,
										type: 'success',
										center: true

									});
									this.list.splice(key, 1) //实际删除内容的索引，删除后页面会刷新删除后的内容，但是实际上没有执行对后台的删除动作
									this.list.splice(id, 1) //实际删除内容的后台id,但删除的内容是key,而且页面不会刷新显示删除的内容

								}
								if (res.data.code == 202)
									this.$message({
										message: res.data.msg,
										type: 'error',
										center: true

									});
							},
							(err) => {
								console.log(err)
							})
					},
					onCancel: () => {

					}
				})



			},

		},
		mounted() {
			this.getdata()
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/group_admin/G_Release.vue